import * as React from 'react';
import { Query } from 'react-apollo';

import ErrorReporter from 'app/components/ErrorReporter';
import FreeClassMembershipLimitNotice from './FreeClassMembershipLimitNotice';

import CLASS_PRODUCT_LIMITS_QUERY from 'groups/queries/ClassProductLimitsQuery.gql';

import { ClassProductLimits } from 'groups/queries/__generated__/ClassProductLimits';

export type Props = {
  groupCode: string;
  groupUuid: string;
  numberOfUsersToAdd: number;
};

export default function FreeClassMembershipLimitNoticeContainer(props: Props) {
  return (
    <Query<ClassProductLimits>
      query={CLASS_PRODUCT_LIMITS_QUERY}
      variables={{ classUuid: props.groupUuid }}>
      {({ loading, error, data }) => {
        if (loading) {
          return null;
        }

        if (!data || error) {
          return (
            <ErrorReporter error="FreeClassMembershipLimitNoticeContainer - failed to fetch classProductLimits" />
          );
        }

        if (data.productLimits) {
          const { classProductLimits } = data.productLimits;

          if (!classProductLimits || !classProductLimits.shouldShowMembershipLimitNotice) {
            return null;
          }

          const addingUsersWillExceedFreeLimit =
            classProductLimits.numberOfPeopleUntilLimit < props.numberOfUsersToAdd;

          if (addingUsersWillExceedFreeLimit || classProductLimits.hasExceededNumberOfPeopleLimit) {
            return (
              <FreeClassMembershipLimitNotice
                numberOfPeopleLimit={classProductLimits.numberOfPeopleLimit}
                groupCode={props.groupCode}
              />
            );
          }
        }

        return null;
      }}
    </Query>
  );
}
